import { render } from "./UploadImg.vue?vue&type=template&id=65306bd9&scoped=true&ts=true&lang=pug"
import script from "./UploadImg.vue?vue&type=script&lang=ts"
export * from "./UploadImg.vue?vue&type=script&lang=ts"

import "./UploadImg.vue?vue&type=style&index=0&id=65306bd9&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65306bd9"]])

export default __exports__